<div class="modal active">
  <div class="modal__container">
      <div class="fields">
          <h2>{{ entity }}</h2>
          <div class="close" (click)="cancel()"><img src="/assets/img/close-white.svg" alt="" /></div>
          <div class="fields__container">
          </div>
      </div>
  </div>
</div>

